export const validateOrganizer = (data, isEdit = false) => {
  const errors = {};

  if (!data.companyName?.trim()) {
    errors.companyName = "Organizer name is required";
  }

  if (!data.companyEmail?.trim()) {
    errors.companyEmail = "Organizer email is required";
  } else if (
    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data.companyEmail)
  ) {
    errors.companyEmail = "Invalid company email";
  }

  if (!data.companyMobile?.trim()) {
    errors.companyMobile = "Organizer mobile is required";
  } else if (!/^[0-9]{7,15}$/.test(data.companyMobile)) {
    errors.companyMobile = "Invalid company mobile number";
  }

  if (!data.companyPhoneNumber?.trim()) {
    errors.companyPhoneNumber = "Organizer phone number is required";
  } else if (!/^[0-9]{7,15}$/.test(data.companyPhoneNumber)) {
    errors.companyPhoneNumber = "Invalid company phone number";
  }

  if (!data.companyCountry) {
    errors.companyCountry = "Country is required";
  }

  if (!data.companyState) {
    errors.companyState = "State is required";
  }

  if (data.companyWebsite?.trim()) {
    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
    if (!urlRegex.test(data.companyWebsite)) {
      errors.companyWebsite = "Invalid website URL";
    }
  }

  if (!isEdit && !data.companyLogo) {
    errors.companyLogo = "Organizer logo is required";
  }

  if (!data.adminName?.trim()) {
    errors.adminName = "Admin name is required";
  }

  if (!data.adminEmail?.trim()) {
    errors.adminEmail = "Admin email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.adminEmail)) {
    errors.adminEmail = "Invalid admin email";
  }

  if (!isEdit && !data.adminPassword?.trim()) {
    errors.adminPassword = "Password is required";
  } else if (
    data.adminPassword &&
    !/^(?=.*[A-Z])(?=.*\d).{8,}$/.test(data.adminPassword)
  ) {
    errors.adminPassword =
      "Min 8 chars, 1 uppercase letter & 1 number required";
  }

  if (!data.adminMobile?.trim()) {
    errors.adminMobile = "Admin mobile is required";
  } else if (!/^[0-9]{7,15}$/.test(data.adminMobile)) {
    errors.adminMobile = "Invalid admin mobile number";
  }

  if (
  data.companyEmail &&
  data.adminEmail &&
  data.companyEmail.trim().toLowerCase() ===
    data.adminEmail.trim().toLowerCase()
) {
  errors.companyEmail = "Must be different from admin email";
  errors.adminEmail = "Must be different from company email";
}

  if (
    data.companyMobile &&
    data.adminMobile &&
    data.companyMobile === data.adminMobile
  ) {
    errors.companyMobile = "Must be different from admin mobile";
    errors.adminMobile = "Must be different from company mobile";
  }

  if (!Array.isArray(data.communicationEmails) || !data.communicationEmails.length) {
    errors.communicationEmails = "At least one communication email is required";
  } else {
    const invalidEmail = data.communicationEmails.find(
      (email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    );

    if (invalidEmail) {
      errors.communicationEmails = "One or more communication emails are invalid";
    }
  }

  return errors;
};
